import { GenericValue } from 'hisng';

export class Address {
    city: string;
    country: GenericValue;
    district: GenericValue;
    street?: string;
    postcode?: string;
    eaddress?: string;
}

export class Business {
    id: number;
    defaulttext: string;
    postAddresses: Address[];
}

export class ResearchPartner {
    id: number;
    business: Business;
    universityObj: number;
    funderCategoryKdsf: GenericValue;
    doctoralCooperationTypeKdsf: GenericValue;
}

export class ResearchPartnerSimple {
    id: number;
    postAddresses: Address[];
    emails?: Address[];
    phones?: Address[];
    hyperlinks?: Address[];
    defaulttext: string;
    funderCategoryKdsf: GenericValue;
    doctoralCooperationTypeKdsf: GenericValue;

    constructor( id: number, defaulttext: string, postAddresses: Address[], funderCategoryKdsf: GenericValue,
        doctoralCooperationTypeKdsf: GenericValue ) {
        this.id = id;
        this.defaulttext = defaulttext;
        this.postAddresses = postAddresses;
        this.funderCategoryKdsf = funderCategoryKdsf;
        this.doctoralCooperationTypeKdsf = doctoralCooperationTypeKdsf;
    }
}
